import React from "react"

import { BaseButton } from "@components/base-button"
import { Icon } from "@components/icon"

import SocialLinks from "../social-links/social-links"

import * as styles from "./mailing-list-banner.module.css"

const MailingListBanner = () => {
  return (
    <div className={styles.container}>
      <div className={styles.subscribe}>
        <div className={styles.title}>Subscribe to our newsletter</div>
        <BaseButton
          type="external"
          to="https://firstfence.us4.list-manage.com/subscribe?u=dcfdcb60cce60745f56cf7a68&id=cabd2e4958"
          blank
          variant="accent"
        >
          <span>Join Our Mailing List</span>
          <Icon id="arrow-right" width="18" height="18" />
        </BaseButton>
      </div>
      <div className={styles.connect}>
        <div className={styles.title}>Connect with us</div>
        <SocialLinks />
      </div>
    </div>
  )
}

export default MailingListBanner
